import React from 'react';
import PropTypes from 'prop-types';
import FileSaver from 'file-saver';

// Fixes Blob is not defined at spec side.
const Blob = window.Blob;

class DownloadFile extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleOnClick = this.handleOnClick.bind(this);
  }

  handleOnClick() {
    const { fileName, getData } = this.props;
    const data = getData();
    const blob = new Blob([data], {type: 'text/plain;charset=utf-8'});
    FileSaver.saveAs(blob, fileName);
  }

  render() {
    const { fileType } = this.props;
    return (
      <a onClick={this.handleOnClick}>
        {fileType}
      </a>
    );
  }
}

DownloadFile.propTypes = {
  fileType: PropTypes.oneOf(['Authors - CSV', 'Authors - TSV', 'Followers connections - TSV',
    'Followers connections - CSV']).isRequired,
  fileName: PropTypes.string.isRequired,
  getData: PropTypes.func.isRequired
};

export default DownloadFile;
